import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import AuthRoute from "@/components/AuthRoute";
import CustomerPage from "@/components/CustomerPage";
import CustomerTabs from "@/components/CustomerTabs";
import { ERROR_404_URL } from "@/core/urls";
import B2CHeader from "@/tpo/header/B2CHeader";

import { OrdersHistory } from "../../orders/OrderHistoryPage";
import OrderDetailPage from "./OrderDetailPage";
import { ORDER_HISTORY_PAGE_QUERY, ORDER_QUERY } from "./graphql";

export default function Routes() {
  const match = useRouteMatch();
  return (
    <Switch>
      <AuthRoute path={match.path} exact>
        <B2CHeader />
        <CustomerPage
          bg="haze"
          jumbotronProps={{
            title: "Orders"
          }}
        >
          <CustomerTabs />
          <OrdersHistory listQuery={ORDER_HISTORY_PAGE_QUERY} detailQuery={ORDER_QUERY} />
        </CustomerPage>
      </AuthRoute>
      <Route path={`${match.path}/:id`} exact>
        <OrderDetailPage />
      </Route>
      <Redirect to={ERROR_404_URL} />
    </Switch>
  );
}
